module.exports = __webpack_public_path__ + "img/logo-invision.4731441a.svg";